import React from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import appshotsBackground from "../../../areas/main/assets/images/background/app-shot-bg.png";
import appshot1 from "../../../areas/main/assets/images/app-shots/app-shot-1-1.jpg";
import appshot2 from "../../../areas/main/assets/images/app-shots/app-shot-1-2.jpg";
import appshot3 from "../../../areas/main/assets/images/app-shots/app-shot-1-3.jpg";
import appshot4 from "../../../areas/main/assets/images/app-shots/app-shot-1-4.jpg";
import appshot5 from "../../../areas/main/assets/images/app-shots/app-shot-1-5.jpg";
import Texts from "../../../utils/lang-utils";
const Screenshots = () => {
  const params = {
    loop: true,
    speed: 1000,
    spaceBetween: 30,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    // Responsive breakpoints
    breakpoints: {
      1499: {
        slidesPerView: 5
      },

      1371: {
        slidesPerView: 4
      },

      963: {
        slidesPerView: 3
      },

      630: {
        slidesPerView: 2
      },

      571: {
        slidesPerView: 1
      }
    }
  };

  return (
    <section className="app-shot-one" id="screenshots">
      <img
        src={appshotsBackground}
        alt="alter text"
        className="app-shot-one__bg"
      />
      <div className="container-fluid">
        <div className="block-title text-center">
          <h2 className="block-title__title" dangerouslySetInnerHTML={{__html: Texts.QRMenu.CheckoutCustomersTitle}} />
          <p dangerouslySetInnerHTML={{__html: Texts.QRMenu.CheckoutCustomersSubtitle}} style={{fontSize: '24px', color: '#ff4eb5'}} />
        </div>
        
        <div className="app-shot-one__carousel">
          <Swiper {...params}>
            <div className="item">
              <img src={appshot1} alt="" />
            </div>
            <div className="item">
              <img src={appshot2} alt="" />
            </div>
            <div className="item">
              <img src={appshot3} alt="" />
            </div>
            <div className="item">
              <img src={appshot4} alt="" />
            </div>
            <div className="item">
              <img src={appshot5} alt="" />
            </div>
            <div className="item">
              <img src={appshot1} alt="" />
            </div>
            <div className="item">
              <img src={appshot2} alt="" />
            </div>
            <div className="item">
              <img src={appshot3} alt="" />
            </div>
            <div className="item">
              <img src={appshot4} alt="" />
            </div>
            <div className="item">
              <img src={appshot5} alt="" />
            </div>
            <div className="item">
              <img src={appshot1} alt="" />
            </div>
            <div className="item">
              <img src={appshot2} alt="" />
            </div>
            <div className="item">
              <img src={appshot3} alt="" />
            </div>
            <div className="item">
              <img src={appshot4} alt="" />
            </div>
            <div className="item">
              <img src={appshot5} alt="" />
            </div>
          </Swiper>
        </div>
      </div>
    </section>
  );
};
export default Screenshots;
